"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin class for EULA related API calls,
 * such as retrieving and accepting the EULA.
 */
var EulaMixin = /** @class */ (function () {
    function EulaMixin() {
    }
    /**
     * Get EULA
     * @param callback
     */
    EulaMixin.prototype.getEula = function (callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Eula.parse));
        };
        this.http.get('/eula', null, wrappedCallback);
    };
    /**
     * Accept EULA
     * @param callback
     */
    EulaMixin.prototype.acceptEula = function (callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put('/users/me/eula', null, null, this.unauthenticatedCallback(wrappedCallback));
    };
    return EulaMixin;
}());
exports.default = EulaMixin;
//# sourceMappingURL=EulaMixin.js.map